import { CloseOutlined } from '@ant-design/icons';
import { Input } from '@mm/components';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import React, { useState } from 'react';
import { extractDomainName } from '../../../dashboard/pages/XRayOnboarding/WebsiteReportSummary/constants';
import { PrimaryButton } from '../../buttons/PrimaryButton/PrimaryButton';
import styles from './ConnectShopifyModal.module.css';

export const ConnectShopifyModal = ({
  defaultShop,
  defaultAccessToken,
  onConnect,
}: {
  onConnect: (shop: string, accessToken: string) => void;
  defaultShop?: string;
  defaultAccessToken?: string;
}) => {
  const [shopifyStore, setShopifyStore] = useState(defaultShop || '');
  const [shopifyAccessToken, setShopifyAccessToken] = useState(
    defaultAccessToken || '',
  );
  const [errors, setErrors] = useState({ shop: '', accessToken: '' });

  const { closeModal } = useModalActions();
  const domainName = extractDomainName(shopifyStore);

  const validateStore = () =>
    domainName && domainName.endsWith('myshopify.com');

  const validateParams = () => {
    if (!shopifyStore || !shopifyAccessToken) {
      setErrors(prev => ({
        ...prev,
        shop: 'Shop if required',
        accessToken: 'Access token is required',
      }));
      return false;
    }

    if (!validateStore()) {
      setErrors(prev => ({
        ...prev,
        shop: 'Incorrect store name. Please, make sure it ends on myshopify.com',
      }));
      return false;
    }
    return true;
  };

  const onConnectStore = () => {
    if (!validateParams() || !domainName) return;

    onConnect(domainName, shopifyAccessToken);
    closeModal();
  };

  return (
    <div className={styles.container}>
      <CloseOutlined
        className={styles.closeIcon}
        onClick={() => closeModal()}
      />

      <div className={styles.block}>
        <div className={styles.heading}>Enter Your Shopify Credentials</div>
      </div>

      <div className={styles.block}>
        Shop:
        <Input
          type="text"
          css={{ container: styles.input }}
          placeholder="example.myshopify.com"
          value={shopifyStore}
          onChange={e => {
            setShopifyStore(e.target.value);
            setErrors(prev => ({ ...prev, shop: '' }));
          }}
        />
        {errors.shop && <div className={styles.error}>{errors.shop}</div>}
      </div>
      <div className={styles.block}>
        Admin API access token:
        <Input
          type="text"
          css={{ container: styles.input }}
          placeholder="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"
          value={shopifyAccessToken}
          onChange={e => {
            setShopifyAccessToken(e.target.value);
            setErrors(prev => ({ ...prev, accessToken: '' }));
          }}
        />
        {errors.accessToken && (
          <div className={styles.error}>{errors.accessToken}</div>
        )}
      </div>

      <PrimaryButton
        className={styles.button}
        onClick={onConnectStore}
        disabled={!shopifyAccessToken || !shopifyStore}
      >
        Confirm & Continue
      </PrimaryButton>
    </div>
  );
};
